import React from "react";

import { Typography } from "@material-ui/core";

import SvgI24LogoWhite from "assets/icons/I24LogoWhite";

import { AppBar, Toolbar, TitleContainer, LogoContainer } from "./styles";

type Props = {
  controls?: React.ReactNode;
};

const Header = ({ controls }: Props) => (
  <AppBar elevation={0}>
    <Toolbar>
      <TitleContainer>
        <LogoContainer>
          <SvgI24LogoWhite />
        </LogoContainer>

        <Typography variant="h2" noWrap>
          FASTer Way
        </Typography>
      </TitleContainer>
      {controls}
    </Toolbar>
  </AppBar>
);

export default Header;
